import React, { useEffect, useState } from "react";
import { Button, CircularProgress, Typography } from "@mui/material";
import ActionModal from "./ActionModal";

const ConfirmActionModal = ({
    open,
    onClose,
    title = "Are you sure?",
    message = "Do you want to proceed?",
    confirmText = "Confirm",
    cancelText = "Cancel",
    width = 400,
    onConfirm
}) => {
    const [loading, setLoading] = useState(false);

    const handleConfirm = async () => {
        setLoading(true);
        try {
            await onConfirm();
        } finally {
            setLoading(false);
        }
    };

    return (
        <ActionModal
            open={open}
            onClose={onClose}
            width={width}
            title={title}
            actions={
                <>
                    <Button
                        onClick={onClose}
                        color="error"
                        variant="contained"
                        disabled={loading}
                        sx={{ mr: 1 }}
                    >
                        {cancelText}
                    </Button>

                    <Button
                        onClick={handleConfirm}
                        color="primary"
                        variant="contained"
                        disabled={loading}
                    >
                        {loading ? (
                            <CircularProgress size={22} sx={{ color: "white" }} />
                        ) : (
                            confirmText
                        )}
                    </Button>
                </>
            }
        >
            <Typography sx={{ fontSize: "16px" }}>{message}</Typography>
        </ActionModal>
    );
};

export default ConfirmActionModal;
